// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Admin: overview
 */

.AdminOverview_page__cvfyN {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.AdminOverview_controls__os-4o {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.AdminOverview_control__Soeru {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 200px;
}

.AdminOverview_check__YFaE- {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: 0.9375rem;
  color: var(--text-secondary);
  padding-bottom: var(--space-2);
}

.AdminOverview_tableWrap__Fbke5 {
  overflow-x: auto;
}

.AdminOverview_table__lwJS5 {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9375rem;
}

.AdminOverview_table__lwJS5 th {
  text-align: left;
  font-weight: 600;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border);
  padding: var(--space-2) var(--space-3);
  white-space: nowrap;
}

.AdminOverview_table__lwJS5 td {
  padding: var(--space-3);
  border-bottom: 1px solid var(--border-light);
  vertical-align: top;
}

.AdminOverview_table__lwJS5 td .ui-badge {
  margin: 0 var(--space-1) var(--space-1) 0;
}

.AdminOverview_row__-j2Ii {
  cursor: pointer;
}

.AdminOverview_row__-j2Ii:hover {
  background: var(--bg-secondary);
}

.AdminOverview_sortBtn__OBVEO {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.AdminOverview_emailBtn__bs497 {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  text-align: left;
  overflow-wrap: anywhere;
}

.AdminOverview_emailBtn__bs497:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.AdminOverview_name__521\\+b {
  display: block;
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.AdminOverview_older__TBREo {
  color: var(--warning);
  font-weight: 600;
}

.AdminOverview_empty__5lF-3,
.AdminOverview_note__J8GV\\+ {
  color: var(--text-secondary);
  font-size: 0.9375rem;
  margin: 0 0 var(--space-3);
}

.AdminOverview_tests__ohsum {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
}

.AdminOverview_tests__ohsum > .ui-card {
  width: 100%;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Admin/AdminOverview.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB","sourcesContent":["/*\n * Admin: overview\n */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.controls {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n}\n\n.control {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 200px;\n}\n\n.check {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  font-size: 0.9375rem;\n  color: var(--text-secondary);\n  padding-bottom: var(--space-2);\n}\n\n.tableWrap {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9375rem;\n}\n\n.table th {\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border);\n  padding: var(--space-2) var(--space-3);\n  white-space: nowrap;\n}\n\n.table td {\n  padding: var(--space-3);\n  border-bottom: 1px solid var(--border-light);\n  vertical-align: top;\n}\n\n.table td :global(.ui-badge) {\n  margin: 0 var(--space-1) var(--space-1) 0;\n}\n\n.row {\n  cursor: pointer;\n}\n\n.row:hover {\n  background: var(--bg-secondary);\n}\n\n.sortBtn {\n  background: none;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.emailBtn {\n  background: none;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  text-align: left;\n  overflow-wrap: anywhere;\n}\n\n.emailBtn:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n.name {\n  display: block;\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.older {\n  color: var(--warning);\n  font-weight: 600;\n}\n\n.empty,\n.note {\n  color: var(--text-secondary);\n  font-size: 0.9375rem;\n  margin: 0 0 var(--space-3);\n}\n\n.tests {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-3);\n}\n\n.tests > :global(.ui-card) {\n  width: 100%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminOverview_page__cvfyN`,
	"controls": `AdminOverview_controls__os-4o`,
	"control": `AdminOverview_control__Soeru`,
	"check": `AdminOverview_check__YFaE-`,
	"tableWrap": `AdminOverview_tableWrap__Fbke5`,
	"table": `AdminOverview_table__lwJS5`,
	"row": `AdminOverview_row__-j2Ii`,
	"sortBtn": `AdminOverview_sortBtn__OBVEO`,
	"emailBtn": `AdminOverview_emailBtn__bs497`,
	"name": `AdminOverview_name__521+b`,
	"older": `AdminOverview_older__TBREo`,
	"empty": `AdminOverview_empty__5lF-3`,
	"note": `AdminOverview_note__J8GV+`,
	"tests": `AdminOverview_tests__ohsum`
};
export default ___CSS_LOADER_EXPORT___;
